import React from 'react'
import Container from 'components/Containers/Container'

export default function Fun() {
  return (
   <Container></Container>
  )
}
